export default __webpack_public_path__ + "static/media/copy-icon.8eb03ea1.svg";